import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const symbols = {
  EGP: "£",
  LBP: "£",
  CHF: "CHF",
  JOD: "JOD",
  SEK: "kr",
  ZAR: "R",
  NOK: "kr",
  DKK: "kr",
  AUD: "$",
  CAD: "$",
  EUR: "€",
  JPY: "¥",
  GBP: "£",
  USD: "$",
  ILS: "₪",
  NIS: "₪",
  PLN: "zł"
};

const mainCurrencies = ["ILS", "NIS", "USD", "EUR"];

const getMappedCurrency = (curr, symbol, isMain) => {
  const currObj = {
    ...curr,
    symbol: symbol,
    main: isMain
  };
  if (curr.unit === 0) currObj.unit = 1;
  return currObj;
};

export const currenciesReducer = (state = initialState.currencies, action) => {
  switch (action.type) {
    // case types.GET_MOCK_CURRENCIES_SUCCESS:
    case types.GET_CURRENCIES_SUCCESS: {
      const currenciesList = [...action.payload];
      const mappedCurrencies = currenciesList.reduce((mapped, current) => {
        if (typeof current === "undefined") return mapped;
        const code = current.currencyCode;
        let symbol = symbols[code];
        if (symbol == null) symbol = code;
        const isMain = mainCurrencies.some(mc => mc === code);
        mapped.push(getMappedCurrency(current, symbol, isMain));
        return mapped;
      }, []);
      const ilsCurrency = {
        name: "NIS", //inside Price Display component, we consider NIS as ILS as well
        unit: "1",
        currencyCode: "NIS",
        country: "Israel",
        rate: "1"
      };
      mappedCurrencies.unshift(
        getMappedCurrency(ilsCurrency, symbols[ilsCurrency.currencyCode], true)
      );
      return mappedCurrencies;
    }
    case types.GET_CURRENCIES_FAILED:
      return initialState.currencies;

    default:
      return state;
  }
};

export const selectedCurrencyReducer = (
  state = initialState.selectedCurrency,
  action
) => {
  switch (action.type) {
    case types.SET_CURRENCY:
      return action.payload;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/currenciesReducer.js